import React from 'react';
import PropTypes from 'prop-types';

import { Card, Typography } from '@sm/wds-react';

import './help-side-bar.scss';

const HelpSideBar = ({ title, helpLinks }) => {
  return (
    <Card padding={false}>
      <div className="wds-p-b-2 sm-help-side-bar__title">
        <Typography variant="cardTitle">{title}</Typography>
      </div>
      <ul data-testid="HelpSideBar__LinksList">
        {helpLinks.map(link => (
          <li className="wds-type--body-sm wds-m-b-2 sm-help-side-bar__list-item" key={link.key}>
            <Choose>
              <When condition={link.path}>
                <a href={link.path} target="_blank" rel="noreferrer noopener">
                  {link.text}
                </a>
              </When>
              <Otherwise>{link.text}</Otherwise>
            </Choose>
          </li>
        ))}
      </ul>
    </Card>
  );
};

HelpSideBar.propTypes = {
  title: PropTypes.string,
  helpLinks: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      path: PropTypes.string,
    })
  ),
};

HelpSideBar.defaultProps = {
  title: '',
  helpLinks: [],
};

export default HelpSideBar;
